import { reorderGroups, updateGroup } from '@repo/redux/actions/groups';
import { ID } from '@repo/utils/types';
import { arrayMove } from '@dnd-kit/sortable';

const dragSource = (e) => e.active?.data?.current || {};

const contactIDsIntoGroup = (dispatch, group, e) => {
  const contactList = dragSource(e).contactIDs.toArray();
  const groupWithAdditions = group.addContactGroup(contactList.map((id) => ({ id })));

  dispatch(
    updateGroup({
      group: groupWithAdditions,
      requestPayload: group.diff(groupWithAdditions),
      isDropEvent: true,
    }),
  );
};

const groupToNewIndex = (dispatch, movedGroupID, e) => {
  const orderedGroupIDs: ID[] = dragSource(e)?.sortable.items;
  const startingIndex = dragSource(e)?.sortable.index;
  const newIndex = e.over?.data?.current?.sortable.index;

  if (
    newIndex != startingIndex &&
    typeof newIndex == 'number' &&
    typeof startingIndex == 'number'
  ) {
    const newGroupOrder = arrayMove(orderedGroupIDs, startingIndex, newIndex);
    dispatch(reorderGroups({ newGroupOrder, movedGroupID, newIndex }));
  }
};

export default function dropHandlers(dispatch, groupsMap) {
  return (e) => {
    const droppedIntoGroupID = e.over?.id;
    const droppedIntoGroup = groupsMap.get(droppedIntoGroupID);
    const draggedID = e.active?.id;
    const dragSourceType = dragSource(e).type;

    if (dragSourceType == 'contactIDs' && droppedIntoGroup) {
      contactIDsIntoGroup(dispatch, droppedIntoGroup, e);
    }

    if (dragSourceType == 'group' && draggedID) {
      groupToNewIndex(dispatch, draggedID, e);
    }
  };
}
